module.exports = __webpack_public_path__ + "img/packing.14e2ea6c.png";